/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectContactEntity } from './subjectContactEntity.model';
import { PurchaseCaseParcelDto } from './purchaseCaseParcelDto.model';
import { ConcernedSubjectFullDto } from './concernedSubjectFullDto.model';
import { DocumentTemplate } from './documentTemplate.model';


export interface PurchaseCaseDto { 
    approvalAcreage?: number;
    approvalDate?: string;
    approvalNumber?: string;
    approvalPrice?: number;
    bankAccountNumber?: string;
    cadastreEntryDate?: string;
    concerned?: ConcernedSubjectFullDto;
    concernedId?: number;
    created?: string;
    entryProposalDate?: string;
    entryProposalId?: number;
    entryProposalLink?: string;
    entryProposalUser?: string;
    id?: number;
    note?: string;
    owners?: Array<SubjectContactEntity>;
    priceBank?: number;
    priceCash?: number;
    priceDeposit?: number;
    priceWhole?: number;
    proceedingNumber?: string;
    purchaseCaseParcels?: Array<PurchaseCaseParcelDto>;
    secondaryCosts?: number;
    signatureDate?: string;
    subjectOrderName?: string;
    template?: DocumentTemplate;
    totalPrice?: number;
}

